// ============================================
// SERVICIO — IMPORTACION MANUAL DE DATOS
// ============================================
// Subida del CSV del gateway al backend. Se usa XMLHttpRequest (no fetch) para
// exponer el progreso de subida, util con archivos de varios MB.

import { API_BASE_URL, fetchJsonWithToken } from '../utils/helpers';

/** ¿El usuario actual tiene permiso para importar? (super admin o acceso granular) */
export async function verificarAccesoImport() {
  try {
    const data = await fetchJsonWithToken('/api/importacion/permiso', { method: 'GET' });
    return Boolean(data?.data?.acceso);
  } catch {
    return false;
  }
}

/**
 * Sube el CSV y devuelve el resumen de importacion.
 * @param {File} archivo
 * @param {{ recalcularRiego?: boolean, confirmarRiego?: boolean }} opciones
 * @param {(pct:number)=>void} [onProgress] - 0..100 (progreso de subida)
 * @returns {Promise<object>} resumen { total, insertadas, duplicadas, ... }
 */
export function importarCsv(archivo, opciones = {}, onProgress) {
  return new Promise((resolve, reject) => {
    const token = sessionStorage.getItem('token');
    const form = new FormData();
    form.append('archivo', archivo);
    form.append('recalcularRiego', opciones.recalcularRiego ? 'true' : 'false');
    form.append('confirmarRiego', opciones.confirmarRiego ? 'true' : 'false');

    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${API_BASE_URL}/api/importacion/manual`);
    if (token) xhr.setRequestHeader('Authorization', token);
    // OJO: NO fijar Content-Type; el navegador agrega el boundary del multipart.

    if (xhr.upload && typeof onProgress === 'function') {
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
      };
    }

    xhr.onload = () => {
      let payload = null;
      try { payload = JSON.parse(xhr.responseText); } catch { /* no-json */ }
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(payload?.data ?? payload ?? {});
      } else {
        const err = new Error(payload?.message || payload?.msg || `HTTP ${xhr.status}`);
        err.status = xhr.status;
        err.payload = payload;
        reject(err);
      }
    };
    xhr.onerror = () => reject(new Error('Error de red al subir el archivo.'));
    xhr.ontimeout = () => reject(new Error('La subida excedió el tiempo de espera.'));
    xhr.timeout = 300000; // 5 min para archivos grandes
    xhr.send(form);
  });
}

export default { verificarAccesoImport, importarCsv };
